export * from './components';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId, dom } from "@omegagrid/core";
import { AppComponent, AppHost, Application, Container, parseComponentId, AppInfo } from '@reporting/rp-app-host';
import { componentFactories } from './factories';
import { DWHSearchProvider } from './searchProvider';

export class DWHApplication extends Application {

	async register(container: Container) {
		super.register(container);
		container.services.register('server');
		container.commands.registerProvider(new DWHSearchProvider());
	}

	async init(container: Container) {
		super.init(container);
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}
}
